module.exports = __webpack_public_path__ + "img/progress.f2002f9b.jpg";